// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2yzQg","content":"ManualTimeModal_content__2G9wW"};